module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "columns is-centered is-gapless",
    staticStyle: {
      "margin-top": "3rem"
    }
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n          Reset Password\n        ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("New Password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('p', {
    staticClass: "help"
  }, [_vm._v("Password should be minimum 8 characters which contain at least one numeric digit and a special character.")])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Retype Password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rePassword),
      expression: "rePassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.rePassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rePassword = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('p', {
    staticClass: "control has-text-centered",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("\n              Submit\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-key"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-key"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-552e06ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/auth/ResetPassword.vue
// module id = 372
// module chunks = 5